var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23 0.469 C 25.503 0.469 27.531 2.497 27.531 5 C 27.531 7.503 25.503 9.531 23 9.531 C 20.497 9.531 18.469 7.503 18.469 5 C 18.469 2.497 20.497 0.469 23 0.469 Z",
    fill: "currentColor",
    strokeWidth: 1,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 23 20.469 C 25.503 20.469 27.531 22.497 27.531 25 C 27.531 27.503 25.503 29.531 23 29.531 C 20.497 29.531 18.469 27.503 18.469 25 C 18.469 22.497 20.497 20.469 23 20.469 Z",
    fill: "currentColor",
    strokeWidth: 1,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 6 9.563 C 9.003 9.563 11.438 11.997 11.438 15 C 11.438 18.003 9.003 20.438 6 20.438 C 2.997 20.438 0.563 18.003 0.563 15 C 0.563 11.997 2.997 9.563 6 9.563 Z",
    fill: "currentColor",
    strokeWidth: 1,
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.907 14.384 L 23.093 3.884 L 24.093 5.616 L 5.907 16.116 Z",
    fill: "currentColor",
    strokeWidth: 3,
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.907 13.884 L 24.093 24.384 L 23.093 26.116 L 4.907 15.616 Z",
    fill: "currentColor",
    strokeWidth: 3,
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 1 0 L 19.187 10.5 L 18.187 12.232 L 0 1.732 Z",
    transform: "translate(4.813 23.768) rotate(-60 9.593 6.116)",
    fill: "currentColor",
    strokeWidth: 3,
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.563 28.125 C 9.566 28.125 12 30.559 12 33.563 C 12 36.566 9.566 39 6.563 39 C 3.559 39 1.125 36.566 1.125 33.563 C 1.125 30.559 3.559 28.125 6.563 28.125 Z",
    fill: "currentColor",
    strokeWidth: 1,
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6e9eafdb.svg";
export { ForwardRef as ReactComponent };